
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenReport } from './GenReport';

export class GenReportGroup {

    id: number;
    displayName: string;
    iconUrl: string;
    ordering: number;
    reports: GenReport[];
    uiHandle: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genReportGroup: GenReportGroup);
    constructor( id: number );

    constructor( input?: GenReportGroup|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.displayName = input.displayName; // string [string]
            this.iconUrl = input.iconUrl; // string [string]
            this.ordering = input.ordering; // int [number]
            if ( input.reports && input.reports.map ) { // list [GenReport]
                this.reports = input.reports.map( ( x: GenReport ) => {
                    return new GenReport( x );
                } );
            } else {
                this.reports = input.reports;
            }
            this.uiHandle = input.uiHandle; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenReportGroup[] {
        if (arr && arr.map) {
          return arr.map(a => new GenReportGroup(a));
        } else {
          return [];
        }
    }
}

